/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */


/** This is for hide/unhide textbox **/

	$(document).ready(function() {
      $('[id="Personalisation"]').change(function(){
  console.log(this.value)
  if (this.value === 'Engraving') {
    document.getElementById('engraving text').value="";
    document.getElementById('font').value="";
    document.getElementById('additional-request-if-any').value="";
    document.getElementById('engraving text').parentElement.removeAttribute('style');
    document.getElementById('font').parentElement.removeAttribute('style');
    document.getElementById('additional-request-if-any').parentElement.removeAttribute('style');
  } else if (this.value === 'No engraving') {
     document.getElementById('engraving text').value="";
    document.getElementById('font').value="";
    document.getElementById('additional-request-if-any').value="";
    document.getElementById('engraving text').parentElement.style.display = 'none';
    document.getElementById('font').parentElement.style.display = 'none';
    document.getElementById('additional-request-if-any').parentElement.style.display = 'none';
  }
})
});

/** Thea **/

$(document).ready(function() {
       $('[id="PersonalisationT"]').change(function(){
  console.log(this.value)
  if (this.value === 'Engraving') {
    document.getElementById('first-side').value="";
    document.getElementById('second-side').value="";
    document.getElementById('third-side').value="";
    document.getElementById('fourth-side').value="";
    document.getElementById('font').value="";
    document.getElementById('additional-request-if-any').value="";
    document.getElementById('first-side').parentElement.removeAttribute('style');
    document.getElementById('second-side').parentElement.removeAttribute('style');
    document.getElementById('third-side').parentElement.removeAttribute('style');
    document.getElementById('fourth-side').parentElement.removeAttribute('style');
    document.getElementById('font').parentElement.removeAttribute('style');
    document.getElementById('additional-request-if-any').parentElement.removeAttribute('style');
  } else if (this.value === 'No engraving') {
    document.getElementById('first-side').value="";
    document.getElementById('second-side').value="";
    document.getElementById('third-side').value="";
    document.getElementById('fourth-side').value="";
    document.getElementById('font').value="";
    document.getElementById('additional-request-if-any').value="";
    document.getElementById('first-side').parentElement.style.display = 'none';
    document.getElementById('second-side').parentElement.style.display = 'none';
    document.getElementById('third-side').parentElement.style.display = 'none';
    document.getElementById('fourth-side').parentElement.style.display = 'none';
    document.getElementById('font').parentElement.style.display = 'none';
    document.getElementById('additional-request-if-any').parentElement.style.display = 'none';
  }
})
});